export const feedbackTypes = {
  FEED_BACK_TYPE_COURSE: 1,
  FEED_BACK_TYPE_NOT_GIVEN: 0,
  FEED_BACK_TYPE_APPROVED: 1,
  FEED_BACK_TYPE_REJECTED: 2,
  FEED_BACK_TYPE_PENDING: 3,
  FEED_BACK_TYPE_COMPETITIONS: 0
};
